export default __webpack_public_path__ + "static/media/Icon-Arrow_Neutral.ceb50aec.svg";